import { action, observable } from 'mobx';

const VALID_REGION_IDS = ['sword', 'green'];

class MatchRewardsStore {
  @observable activeRegionId = 'sword';

  use() {}

  @action.bound
  setActiveRegion(regionId) {
    if (!VALID_REGION_IDS.includes(regionId) || this.activeRegionId === regionId) {
      return false;
    }

    this.activeRegionId = regionId;
    return true;
  }
}

export default MatchRewardsStore;
